import type { VotingPlace } from '@/types/votingPlace'
import { VotingPlaceListItem } from './VotingPlaceListItem'

interface Props {
  recintos: VotingPlace[]
  totalCount: number
  selectedRecintoId: string | null
  onSelectRecinto: (id: string) => void
}

export function VotingPlaceList({
  recintos,
  totalCount,
  selectedRecintoId,
  onSelectRecinto,
}: Props) {
  return (
    <div className="voting-list" aria-label="Resultados de recintos">
      <header className="voting-list__header">
        <strong>{totalCount} recintos encontrados</strong>
        <span>{recintos.length < totalCount ? `Mostrando ${recintos.length}. Refina tu búsqueda.` : 'Selecciona un recinto para ver el detalle.'}</span>
      </header>

      <div className="voting-list__items" role="list">
        {recintos.map((recinto) => (
          <VotingPlaceListItem
            key={recinto.id}
            recinto={recinto}
            selected={recinto.id === selectedRecintoId}
            onSelect={() => onSelectRecinto(recinto.id)}
          />
        ))}
      </div>
    </div>
  )
}
